module.exports = __webpack_public_path__ + "66405807bef19cc7fa512af84ca4f56b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-wizard.png
// module id = 3241
// module chunks = 0